module.exports = __webpack_public_path__ + "static/media/Autor.dbc32640.jpg";